import * as React from "react";
import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

// import MaterialTable from '@material-table/core';
// import { Checkbox } from "@material-ui/core";
// import FormLabel from "@mui/material/FormLabel";
// import FormControl from "@mui/material/FormControl";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";

import { TagService } from "../../services/DataService";
import { DocumentTag, DataTag, EmptyGuid } from "../../models";

export default function Tags(): JSX.Element {
    const [documentTags, setDocumentTags] = useState([] as DocumentTag[]);
    const [stageDocumentTags, setStageDocumentTags] = useState(
        [] as DocumentTag[]
    );
    const [stageDataTags, setStageDataTags] = useState([] as DataTag[]);
    const [dataTags, setDataTags] = useState([] as DataTag[]);
    const [errorMessage, setErrorMessage] = useState("");
    const [dataLoad, setDataLoad] = useState(true);
    const [documentLoad, setDocumentLoad] = useState(true);
    const [isError, setIsError] = useState(false);
    const [isInactiveDocTags, setIsInactiveDocTags] = useState(false);
    const [isInactiveDataTags, setIsInactiveDataTags] = useState(false);
    const [isEditingDoc, setIsEditingDoc] = useState(false);
    const [isEditingData, setIsEditingData] = useState(false);

    useEffect(() => {
        if (errorMessage !== "") {
            setIsError(true);
        }
    }, [errorMessage]);

    useEffect(() => {
        console.log("Smoke");
        documentLoad &&
            TagService.getActiveDocTags().then(
                (response) => {
                    if (response.length > 0) {
                        setDocumentTags(response);
                    } else {
                        setErrorMessage(
                            "An error has occurred try again later."
                        );
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
        if (errorMessage !== "") {
            setErrorMessage(errorMessage);
        }
        setDocumentLoad(false);
    });

    useEffect(() => {
        dataLoad &&
            TagService.getActiveDataTags().then(
                (response) => {
                    if (response.length > 0) {
                        setDataTags(response);
                    } else {
                        setErrorMessage(
                            "An error has occurred try again later."
                        );
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
        if (errorMessage !== "") {
            setErrorMessage(errorMessage);
        }
        setDataLoad(false);
    });

    useEffect(() => {
        if (isInactiveDocTags) {
            TagService.getDocTags().then(
                (response) => {
                    if (response.length > 0) {
                        setDocumentTags(response);
                    } else {
                        setErrorMessage("An API error occurred.");
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
        } else {
            TagService.getActiveDocTags().then(
                (response) => {
                    if (response.length > 0) {
                        setDocumentTags(response);
                    } else {
                        setErrorMessage(
                            "An error has occurred try again later."
                        );
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
        }
    }, [isInactiveDocTags]);

    useEffect(() => {
        if (isInactiveDataTags) {
            TagService.getDataTags().then(
                (response) => {
                    if (response.length > 0) {
                        setDataTags(response);
                    } else {
                        setErrorMessage("An API error occurred.");
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
        } else {
            TagService.getActiveDataTags().then(
                (response) => {
                    if (response.length > 0) {
                        setDataTags(response);
                    } else {
                        setErrorMessage(
                            "An error has occurred try again later."
                        );
                    }
                },
                (error) => {
                    setErrorMessage(error);
                }
            );
        }
    }, [isInactiveDataTags]);

    return <></>;

    // return (
    //     <div>
    //         <Modal
    //             show={isError}
    //             size="lg"
    //             aria-labelledby="contained-modal-title-vcenter"
    //             centered
    //         >
    //             <Modal.Header>
    //                 <Modal.Title id="contained-modal-title-vcenter">
    //                     An Error Has Occurred.
    //                 </Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 {errorMessage !== "" && (
    //                     <label style={{ color: "red" }}>{errorMessage}</label>
    //                 )}
    //             </Modal.Body>
    //             <Modal.Footer>
    //                 <label style={{ float: "left", color: "red" }}>
    //                     {errorMessage}
    //                 </label>
    //                 <Button
    //                     className="btn-danger"
    //                     onClick={() => setIsError(false)}
    //                 >
    //                     Ok
    //                 </Button>
    //             </Modal.Footer>
    //         </Modal>
    //         <div className="card-body">
    //             <div style={{ maxWidth: "100%", zIndex: -1 }}>
    //                 <MaterialTable
    //                     columns={[
    //                         {
    //                             title: "ID",
    //                             field: "id",
    //                             editable: "never",
    //                         },
    //                         {
    //                             title: "Document Type",
    //                             field: "text",
    //                         },
    //                         {
    //                             title: "Display Text",
    //                             field: "display",
    //                         },
    //                         {
    //                             title: "Classification",
    //                             field: "type",
    //                         },
    //                         {
    //                             title: "Amount Dependent",
    //                             field: "isAmountDependent",
    //                             type: "boolean" as const,
    //                         },
    //                         {
    //                             title: "Active?",
    //                             field: "isActive",
    //                             type: "boolean" as const,
    //                         },
    //                     ]}
    //                     data={documentTags}
    //                     title="Document Tags"
    //                     editable={{
    //                         onRowAdd: (newData) =>
    //                             new Promise((resolve, reject) => {
    //                                 TagService.updateOrInsertDocTag({
    //                                     body: newData,
    //                                 }).then(
    //                                     (resp) => {
    //                                         const temp = [...documentTags];
    //                                         const index = temp.findIndex(
    //                                             (v) => v.id === resp.id
    //                                         );
    //                                         temp.splice(index, 1);
    //                                         setDocumentTags(temp);
    //                                         resolve(null);
    //                                         setDocumentLoad(true);
    //                                     },
    //                                     (err) => {
    //                                         setErrorMessage(err);
    //                                         resolve(null);
    //                                     }
    //                                 );
    //                             }),
    //                         onRowUpdate: (newData, oldData) =>
    //                             new Promise((resolve, reject) => {
    //                                 TagService.updateOrInsertDocTag({
    //                                     body: newData,
    //                                 }).then(
    //                                     (resp) => {
    //                                         const temp = [...documentTags];
    //                                         const index = temp.findIndex(
    //                                             (v) => v.id === resp.id
    //                                         );
    //                                         temp.splice(index, 1);
    //                                         setDocumentTags(temp);
    //                                         resolve(null);
    //                                         setDocumentLoad(true);
    //                                     },
    //                                     (err) => {
    //                                         setErrorMessage(err);
    //                                         resolve(null);
    //                                     }
    //                                 );
    //                             }),
    //                         onRowDelete: (oldData) =>
    //                             new Promise((resolve, reject) => {
    //                                 TagService.deleteDocTag({
    //                                     id: oldData.id ?? "",
    //                                 }).then(
    //                                     (resp) => {
    //                                         const temp = [...documentTags];
    //                                         const index = temp.findIndex(
    //                                             (v) => v.id === resp.id
    //                                         );
    //                                         temp.splice(index, 1);
    //                                         setDocumentTags(temp);
    //                                         resolve(null);
    //                                         setDocumentLoad(true);
    //                                     },
    //                                     (err) => {
    //                                         setErrorMessage(err);
    //                                         resolve(null);
    //                                     }
    //                                 );
    //                             }),
    //                     }}
    //                 />
    //             </div>
    //             <FormGroup>
    //                 <FormControlLabel
    //                     control={
    //                         <Checkbox
    //                             onChange={() =>
    //                                 setIsInactiveDocTags(!isInactiveDocTags)
    //                             }
    //                         />
    //                     }
    //                     label={"Show Inactive Document Tags"}
    //                     labelPlacement={"start"}
    //                 />
    //             </FormGroup>
    //         </div>
    //         <div className="card-body">
    //             <div style={{ maxWidth: "100%", zIndex: -1 }}>
    //                 <MaterialTable
    //                     columns={[
    //                         {
    //                             title: "ID",
    //                             field: "id",
    //                             editable: "never",
    //                         },
    //                         {
    //                             title: "LAS Tag",
    //                             field: "tag",
    //                         },
    //                         {
    //                             title: "Display Text",
    //                             field: "text",
    //                         },
    //                         {
    //                             title: "Amount Dependent",
    //                             field: "isAmountDependent",
    //                             type: "boolean" as const,
    //                         },
    //                         {
    //                             title: "Active?",
    //                             field: "isActive",
    //                             type: "boolean" as const,
    //                         },
    //                     ]}
    //                     data={dataTags}
    //                     title="Data Tags"
    //                     editable={{
    //                         onRowAdd: (newData) =>
    //                             new Promise((resolve, reject) => {
    //                                 newData.id = EmptyGuid;
    //                                 TagService.updateOrInsertDataTag({
    //                                     body: newData,
    //                                 }).then(
    //                                     (resp) => {
    //                                         const temp = [...dataTags];
    //                                         const index = temp.findIndex(
    //                                             (v) => v.id === resp.id
    //                                         );
    //                                         temp.splice(index, 1, newData);
    //                                         setDataTags(temp);
    //                                         resolve(null);
    //                                         setDataLoad(true);
    //                                     },
    //                                     (err) => {
    //                                         setErrorMessage(err);
    //                                         resolve(null);
    //                                     }
    //                                 );
    //                             }),
    //                         onRowUpdate: (newData, oldData) =>
    //                             new Promise((resolve, reject) => {
    //                                 TagService.updateOrInsertDataTag({
    //                                     body: newData,
    //                                 }).then(
    //                                     (resp) => {
    //                                         const temp = [...dataTags];
    //                                         const index = temp.findIndex(
    //                                             (v) => v.id === resp.id
    //                                         );
    //                                         temp.splice(index, 1, newData);
    //                                         setDataTags(temp);
    //                                         resolve(null);
    //                                         setDataLoad(true);
    //                                     },
    //                                     (err) => {
    //                                         setErrorMessage(err);
    //                                         resolve(null);
    //                                     }
    //                                 );
    //                             }),
    //                         onRowDelete: (oldData) =>
    //                             new Promise((resolve, reject) => {
    //                                 TagService.deleteDataTag({
    //                                     id: oldData.id ?? "",
    //                                 }).then(
    //                                     (resp) => {
    //                                         const temp = [...dataTags];
    //                                         const index = temp.findIndex(
    //                                             (v) => v.id === oldData.id
    //                                         );
    //                                         temp.splice(index, 1);
    //                                         setDataTags(temp);
    //                                         resolve(null);
    //                                         setDataLoad(true);
    //                                     },
    //                                     (err) => {
    //                                         setErrorMessage(err);
    //                                         resolve(null);
    //                                     }
    //                                 );
    //                             }),
    //                     }}
    //                 />
    //             </div>
    //             <FormGroup style={{ float: "right" }}>
    //                 <FormControlLabel
    //                     control={
    //                         <Checkbox
    //                             onChange={() =>
    //                                 setIsInactiveDataTags(!isInactiveDataTags)
    //                             }
    //                         />
    //                     }
    //                     label={"Show Inactive Data Tags"}
    //                     labelPlacement={"start"}
    //                 />
    //             </FormGroup>
    //         </div>
    //     </div>
    // );
}
